import { render, staticRenderFns } from "./PersonTaskDialog.vue?vue&type=template&id=3ccbd0a9&"
import script from "./PersonTaskDialog.vue?vue&type=script&lang=js&"
export * from "./PersonTaskDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports